import"./Select.css.ts.vanilla.css";var e={container:"Select_styles_container__1p7e9cu0",select:"Select_styles_select__1p7e9cu1",caret:"Select_styles_caret__1p7e9cu2",svg:"Select_styles_svg__1p7e9cu3"};export{e as styles};
//# sourceMappingURL=Select.css.vanilla.js.map
